import React from 'react';

export default class ToolHeader extends React.Component{

  render(){ 

    return(
      <div className="tool-header" >
        {this.props.name}
      </div>
    );
  }

}